export default __webpack_public_path__ + "static/media/EESymbolsImg10.2b411bb1.jpg";